import React, { useState } from "react";
import { CalendarDays, Users } from "lucide-react";
import HybridCalendar from "@/pages/rrhh/HybridCalendar";
import TeamCalendar from "@/pages/rrhh/TeamCalendar";

export default function CalendarTab() {
  const [view, setView] = useState("mine");
  return (
    <div className="space-y-4" data-testid="rrhh-calendar-tab">
      <div className="inline-flex overflow-hidden rounded-lg border">
        <button onClick={() => setView("mine")} data-testid="cal-view-mine"
          className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium transition-colors ${view === "mine" ? "bg-primary text-primary-foreground" : "bg-card hover:bg-muted"}`}>
          <CalendarDays className="h-4 w-4" />Mi calendario
        </button>
        <button onClick={() => setView("team")} data-testid="cal-view-team"
          className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium transition-colors ${view === "team" ? "bg-primary text-primary-foreground" : "bg-card hover:bg-muted"}`}>
          <Users className="h-4 w-4" />Calendario de equipo
        </button>
      </div>
      {view === "mine" ? <HybridCalendar /> : <TeamCalendar />}
    </div>
  );
}
